import PageLayout from 'pages/InstructorAssignments/PageLayout';
import PageProvider from 'pages/InstructorAssignments/PageProvider';

const InstructorAssignmentsPage = ({ ...props }) => {
    return (
        <PageProvider {...props}>
            <PageLayout {...props} />
        </PageProvider>
    );
};

export default InstructorAssignmentsPage;
